import React, { useState, useEffect } from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  FormControl,
  Box,
  Text,
} from "@chakra-ui/react";
import { COLORS } from "../styles/colors";

const DropdownWithMultiLingual = ({ 
  options, 
  onClick, 
  onChange, 
  placeholder, 
  value, 
  dataIds, 
  inputStyleCss, 
  menuList,
  title // New prop for the title
}) => {
  const [selectedValue, setSelectedValue] = useState("");

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelect = (option) => {
    setSelectedValue(option.value);
    if (onClick) {
      onClick(option);
    }
  };

  return (
    <FormControl position="relative">
      <Menu placement="bottom-start" matchWidth>
        <MenuButton
          as={Button}
          w="100%"
          h="48px"
          fontSize="14px"
          fontWeight="500"
          color="#384052"
          borderRadius="10px"
          className="textOverflow"
          px="0.7rem"
          textAlign="left"
          bg="white"
          border="1px solid #E6E7E9"
          _active={{ bg: "none" }}
          _hover={{ bg: "none", outline: "none", border: `2px solid ${COLORS.INPUT_FOCUS_DARK}` }}
          _focus={{ bg: "none", outline: "none", border: "none", boxShadow: `0 0 0 2px ${COLORS.INPUT_FOCUS_DARK}` }}
          {...inputStyleCss}
          isTruncated
          position="relative"
          pt="20px" // Always add top padding for title
          pb="8px"
        >
          {/* Title ALWAYS inside the input field at top */}
          {title && (
            <Text
              position="absolute"
              top="6px"
              left="12px"
              fontSize="11px"
              fontWeight="600"
              color="#666"
              lineHeight="1"
            >
              {title}
            </Text>
          )}
          
          {/* Selected value or placeholder */}
          <Box as="span" display="block" mt="2px">
            {selectedValue || placeholder}
          </Box>
        </MenuButton>
        
        <MenuList maxH="200px" overflowY="auto" w="100%" {...menuList}>
          {options?.map((option, index) => (
            <MenuItem
              key={index}
              fontSize="14px"
              lineHeight="normal"
              fontWeight="500"
              color="#384052"
              onClick={() => handleSelect(option)}
            >
              {option.value}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </FormControl>
  );
};

export default DropdownWithMultiLingual;